import React, { useState, useEffect, useMemo, useRef } from 'react'
import ErrorBoundary from '../../Utility/Components/ErrorBoundary'
import CustomInput from '../../Utility/Components/CustomInput';
import Utility from '../../Utility/Utility';
import PhoneNumberWithCountryCode from '../../Utility/Components/PhoneNumberWithCountryCode';
import parsePhoneNumber from 'libphonenumber-js'
import ModalGlobal from '../../Utility/Components/ModalGlobal';
import ImageCropContent from '../../Utility/Components/ImageCropContent';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../Actions/AllAction';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { hotelList, supportCreate } from '../Controller/SupportUserController';
import AssignBusinessModalContent from './AssignBusinessModalContent';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ConfirmationAlert from '../../Utility/Components/ConfirmationAlert';

function AddSupportUserModalContent(props) {
    const [supportUserFormData, setSupportUserFormData] = useState({
        "first_name": "",
        "last_name": "",
        "email": "",
        "contact_number": "",
        "profile_image": "",
        "two_factor_login": false,
        "two_factor_method": "sms"
    });
    const [supportUserFormDataError, setSupportUserFormDataError] = useState({
        "first_name": "",
        "last_name": "",
        "email": "",
        "contact_number": "",
        'selected_business': ''
    });
    const [addprofileImageSelected, setAddprofileImageSelected] = useState(require('../../Utility/Public/images/profile-back.png'));
    const imageRef = useRef();
    const [addProfileImagePreviewShow, setAddProfileImagePreviewShow] = useState(false);
    const [imageCropModalFlag, setImageCropModalFlag] = useState(false);
    const [src, setSrc] = useState(null);
    const [crop, setCrop] = useState({
        unit: '%',
        width: 30,
        // aspect: 1 / 1
    })
    const [croppedImageUrl, setCroppedImageUrl] = useState("");
    const [phoneNumberCountryCode, setPhoneNumberCountryCode] = useState("in");
    const [phoneNumberDialCode, setPhoneNumberDialCode] = useState("91");
    const [isOpenForBusiness, setIsOpenForBusiness] = useState(false);
    const dropdownRefForBusiness = useRef(null);
    var selectRefForBusiness = null;
    const [businessFilterList, setBusinessFilterList] = useState([]);
    const [hotelBusinessFilterSelectedValue, setHotelBusinessFilterSelectedValue] = useState([]);
    const [businessFilterFlag, setBusinessFilterFlag] = useState(false);
    const supportUserAddRef = useRef(true);
    const [profileImagePreview, setProfileImagePreview] = useState({});

    //
    const [selectedBusinessList, setSelectedBusinessList] = useState([]);
    const [businessListModalFlag, setBusinessListModalFlag] = useState(false);
    const [selectAllBusiness, setSelectAllBusiness] = useState(false);
    const [totalBusiness, setTotalBusiness] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false);

    const [excludeId, setExcludeId] = useState([]);

    const [includeId, setincludeId] = useState([]);

    const [selectAllBusinessOnlyAction, setSelectAllBusinessOnlyAction] = useState(false);

    //unified cognito
    const [cognitoUser, setCognitoUser] = useState(null);
    const [cognitoUserConfirmationPopUpFlag, setCognitoUserConfirmationPopUpFlag] = useState(false);

    const maxItems = 10;
    const displayedItems = isExpanded ? selectedBusinessList : selectedBusinessList.slice(0, maxItems);

    //in edit mode set business ids 
    useEffect(() => {
        if (businessFilterList.length > 0 && props.editedFlag && props.editRowData.hasOwnProperty('business_ids') && props.editRowData.business_ids && props.editRowData.business_ids.length > 0) {
            props.loaderStateTrue();
            setEditBusinessIdsFn();
        }
    }, [businessFilterList])

    //in edit mode , set data in all fields
    useEffect(() => {
        if (props.editedFlag) {
            setEditDatasetFn()
        }
    }, [props.editedFlag])

    //edit mode dataset for support user 
    const setEditDatasetFn = () => {
        let dataSet = props.editRowData
        if (Object.keys(dataSet).length > 0) {
            setSupportUserFormData((prevObject) => ({
                ...prevObject,
                "first_name": dataSet.first_name != "" ? dataSet.first_name : "",
                "last_name": dataSet.last_name != "" ? dataSet.last_name : "",
                "email": dataSet.email != "" ? dataSet.email : "",
                "contact_number": dataSet.contact_number != "" ? dataSet.contact_number : ""
            }));
            setAddprofileImageSelected(dataSet.profile_img_url != null && dataSet.profile_img_url != "" ? JSON.parse(dataSet.profile_img_url).img_url : require('../../Utility/Public/images/profile-back.png'))
            setAddProfileImagePreviewShow(dataSet.profile_img_url != null && dataSet.profile_img_url != "" ? true : false)

            let businessIds = props.editRowData.hasOwnProperty("UserOrgBranchRoleRelation") && props.editRowData.UserOrgBranchRoleRelation ? props.editRowData.UserOrgBranchRoleRelation : []
            let businessFilterSelectedValue = []
            let includeValue = []
            if (businessIds && businessIds.length > 0) {
                businessFilterSelectedValue = businessIds.map(business => ({
                    ...business,
                    org_name: business?.OrgUserRelation?.org_name,
                    //value: business?.OrgUserRelation?.id,
                    value: business?.OrgUserRelation?.id || business?.org_id,
                    id: business?.OrgUserRelation?.id || business?.org_id,
                    org_id: business?.org_id,
                    "check": true
                }));

                //includeValue = businessIds.map(business => business.id);
                includeValue = businessIds.map(business => business.org_id);
            }
            setincludeId(includeValue)
            setSelectedBusinessList(businessFilterSelectedValue)
            /*if (dataSet.hasOwnProperty('select_all_business') && dataSet.select_all_business) {
                setSelectAllBusiness(dataSet.select_all_business)
                setSelectAllBusinessOnlyAction(dataSet.select_all_business)
            }*/
            if (dataSet.hasOwnProperty('select_all_business')) {
                setSelectAllBusiness(dataSet.select_all_business)
                setSelectAllBusinessOnlyAction(dataSet.select_all_business)
            } else {
                setSelectAllBusiness(false)
                setSelectAllBusinessOnlyAction(false)
            }
        }
    }

    //business id set in edit mode
    const setEditBusinessIdsFn = async () => {
        let businessIds = props.editRowData.business_ids
        let businessFilterSelectedValue = []
        let includeValue = []
        if (businessIds.length > 0) {
            businessFilterSelectedValue = businessIds.map(business => ({
                ...business,
                "check": true
            }));
            includeValue = businessIds.map(business => business.id);
        }
        setSelectedBusinessList(businessFilterSelectedValue)
        props.loaderStateFalse();
    }

    //support user's modal input fields handle change fn
    const handelChange = (e, type, countryCode = {}) => {
        let tempFormData = { ...supportUserFormData };
        let tempErrorFormData = { ...supportUserFormDataError }
        if (type == "first_name") {
            var expr = /^[a-zA-Z ]*$/;
            if (!expr.test(e.target.value)) {
            } else {
                if (e.target.value == "") {
                    tempErrorFormData['first_name'] = ""
                    tempFormData["first_name"] = ""
                } else {
                    tempFormData["first_name"] = e.target.value
                    tempErrorFormData['first_name'] = ""
                }
            }
        }
        if (type == "last_name") {
            var expr = /^[a-zA-Z ]*$/;
            if (!expr.test(e.target.value)) {
            } else {
                if (e.target.value == "") {
                    tempErrorFormData['last_name'] = ""
                    tempFormData["last_name"] = ""
                } else {
                    tempFormData["last_name"] = e.target.value
                    tempErrorFormData['last_name'] = ""
                }
            }
        }

        if (type == "email") {
            if (e.target.value != "") {
                let emailValidate = validate_email(e.target.value);
                if (emailValidate) {
                    tempFormData["email"] = e.target.value,
                        tempErrorFormData['email'] = ""
                } else {
                    tempFormData["email"] = e.target.value,
                        tempErrorFormData['email'] = "Enter valid email"
                }
            } else {
                tempFormData["email"] = "",
                    tempErrorFormData['email'] = ""
            }
        }

        if (type == "contact_number") {
            if (e.trim() !== "") {
                let modifiedString = deleteAndBefore(e, countryCode.dialCode);
                let countryCodeValue = countryCode.countryCode.toUpperCase();
                const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
                setPhoneNumberCountryCode(countryCode.countryCode)
                setPhoneNumberDialCode(countryCode.dialCode)
                if (phoneNumber && phoneNumber.isValid()) {
                    tempFormData["contact_number"] = e
                    tempErrorFormData['contact_number'] = ""
                } else {
                    tempFormData["contact_number"] = e
                    tempErrorFormData['contact_number'] = "Enter valid phone number"
                }
            } else {
                tempFormData["contact_number"] = "";
                tempErrorFormData['contact_number'] = "Required field";
            }
        }

        if (type == "two_factor_login") {
            if (e.target.checked) {
                tempFormData["two_factor_login"] = true;
            } else {
                tempFormData["two_factor_login"] = false;
            }
        }
        if (type == "sms") {
            if (e.target.checked) {
                tempFormData["two_factor_method"] = "sms";
            }
        }
        if (type == "authenticator") {
            if (e.target.checked) {
                tempFormData["two_factor_method"] = 'authenticator';
            }
        }

        setSupportUserFormData(tempFormData)
        setSupportUserFormDataError(tempErrorFormData)
    }

    useEffect(() => {
    }, [supportUserFormData])

    //phone number formatting according to country code
    const deleteAndBefore = (phoneNumber, countryCode) => {
        var escapedCountryCode = countryCode.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        var regex = new RegExp("^" + escapedCountryCode);
        return phoneNumber.replace(regex, "");
    }
    //email validation fn 
    const validate_email = (value) => {
        var number = value;
        var filter = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (filter.test(number)) {
            return true;
        }
        else {
            return false;
        }
    }

    //support user image upload onchange fn
    const addInputProfileImageChanged = (event) => {
        let tempformData = { ...supportUserFormData };
        let temperrorFormData = { ...supportUserFormDataError };
        let targetFileSplit = event.target.files[0].name.split('.');
        let lastElement = targetFileSplit.pop();
        let user_profile_image = {
            "file_name": "",
            "file_obj": ""
        };
        const file = event.target.files[0];
        const allowedTypes = Utility.acceptFileType();
        Utility.checkFileType(file, allowedTypes)
            .then(results => {
                if (results.isValid) {
                    const fsize = event.target.files[0].size;
                    const fileSize = Math.round((fsize / 1024));
                    if (fileSize >= 300) {
                        Utility.toastNotifications('File is too Big, please select a file less than 300kb', "Warning", "warning");
                    } else {
                        setImageCropModalFlag(true)
                        if (event.target.files && event.target.files.length > 0) {
                            const reader = new FileReader();
                            reader.addEventListener('load', () =>
                                setSrc(reader.result)
                            );
                            reader.readAsDataURL(event.target.files[0]);
                            user_profile_image["file_name"] = event.target.files[0].name
                            user_profile_image["file_obj"] = ""
                            setProfileImagePreview(user_profile_image);
                            temperrorFormData['profile_image'] = ""
                            setAddProfileImagePreviewShow(true)
                        }
                    }
                } else {
                    tempformData['profile_image'] = "";
                    temperrorFormData['profile_image'] = 'Required Field';
                    setAddProfileImagePreviewShow(false);
                    setAddprofileImageSelected('');
                    Utility.toastNotifications("File format is not supported, it should be in jpg, jpeg or png format", "Warning", "warning");
                }
            })
            .catch(error => {
                console.error("Error:", error);

            });

        setSupportUserFormData(tempformData)
        setSupportUserFormDataError(temperrorFormData)
    }

    //image load fn
    const onImageLoaded = (image) => {
        if (image) {
            imageRef.current = image
        }
    };

    //crop button click on crop image modal
    const onCropComplete = (crop) => {
        makeClientCrop(crop);
    };

    //after choose crop area onchange
    const onCropChange = (crop, percentCrop) => {
        setCrop(crop)
    };

    //image crop fn
    const makeClientCrop = async (crop) => {
        let tempformData = { ...supportUserFormData };
        if (imageRef && crop.width && crop.height) {
            const croppedImageUrl = await getCroppedImg(
                imageRef.current,
                crop,
                'newFile.jpeg'
            );
            let user_profile_image = {}

            setAddprofileImageSelected(croppedImageUrl)
            user_profile_image["file_name"] = profileImagePreview?.file_name
            user_profile_image["file_obj"] = croppedImageUrl
            setProfileImagePreview(user_profile_image);
        }
    }

    //create image canvas after crop
    const getCroppedImg = (image, crop, fileName) => {
        const canvas = document.createElement('canvas');
        const pixelRatio = window.devicePixelRatio;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');
        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;
        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );
        const base64Image = canvas.toDataURL('image/jpeg');
        return base64Image
    }

    //Image crop modal fn
    const imageCropModalShow = () => {
        setImageCropModalFlag(true)
    }

    //image crop modal close fn
    const imageCropModalHide = () => {
        supportUserFormData['profile_image'] = "",
            supportUserFormDataError['profile_image'] = "",
            setImageCropModalFlag(false)
        setAddprofileImageSelected(require('../../Utility/Public/images/profile-back.png'))
        setAddProfileImagePreviewShow(false),
            setSrc(null),
            setCrop({
                unit: '%',
                width: 30,
            }),
            setCroppedImageUrl("")
    }

    //Cropped image save to state
    const imageCropDataSave = () => {
        if (profileImagePreview.hasOwnProperty("file_obj") && profileImagePreview.file_obj != "") {
            let tempformData = { ...supportUserFormData };
            tempformData['profile_image'] = profileImagePreview;
            setSupportUserFormData(tempformData)
        } else {
            Utility.toastNotifications('Please select an area to crop profile image', 'Warning', 'warning');
        }
        setImageCropModalFlag(false)
    }


    //formatting dataset of assign business fn
    const formatingDataset = (isSame = false) => {
        let dataset = [];
        let hash = {}
        if (supportUserFormData.first_name != "") {
            hash['first_name'] = (supportUserFormData.first_name).trim();
        }
        if (supportUserFormData.last_name != "") {
            hash['last_name'] = (supportUserFormData.last_name).trim();
        }
        if (supportUserFormData.email && supportUserFormData.email.trim() != "") {
            hash['email'] = supportUserFormData.email.trim();
        }

        var phoneNumber = supportUserFormData.contact_number
        var plusRemovePhoneNumber = phoneNumber.replace(/\+/g, '')
        if (supportUserFormData.contact_number != "") {
            hash['contact_number'] = plusRemovePhoneNumber;
        }

        if (supportUserFormData.profile_image != "") {
            hash['profile_img_url'] = supportUserFormData.profile_image != "" ? supportUserFormData.profile_image : "";
        }

        hash['select_all_business'] = selectAllBusiness;

        if (props.editedFlag) {
            hash['org_ids'] = includeId;
        } else {
            if (excludeId.length == 0) {
                if (!selectAllBusiness && selectedBusinessList.length > 0) {
                    let business_ids = selectedBusinessList
                        .filter(item => item.check === true)  // Filter only items where check is true
                        .map(item => item.id);  // Map the filtered items to their id

                    hash['org_ids'] = business_ids;
                }
            } else {
                hash['excluded_ids'] = excludeId;
            }
        }

        // hash['is_mfa_enabled'] = supportUserFormData.two_factor_login;
        // hash['user_type'] = "support_user";
        hash['is_support_user'] = true;
        if (props.editedFlag) {
            // hash['is_active'] = props.editRowData.is_active;
        } else {
            hash['is_active'] = true;
        }
        if (supportUserFormData.two_factor_login) {
            hash['enabled_type'] = supportUserFormData.two_factor_method == "sms" ? "sms" : "token";
        }
        if (isSame) {
            // hash['is_same_credential'] = true;
            hash['first_name'] = cognitoUser?.first_name || '';
            hash['last_name'] = cognitoUser?.last_name || '';
            hash['contact_number'] = cognitoUser?.contact_number || '';
            hash['email'] = cognitoUser?.email || '';
        }
        dataset.push(hash)
        return dataset;
    }

    //assign business modal data validation
    const validationFromData = () => {
        let tempFormData = { ...supportUserFormData }
        let tempErrorFormData = { ...supportUserFormDataError }
        let valid = true
        if ((tempFormData.first_name).trim() == "") {
            tempErrorFormData['first_name'] = "Required field"
            valid = false
        }
        if ((tempFormData.last_name).trim() == "") {
            tempErrorFormData['last_name'] = "Required field"
            valid = false
        }
        if (tempFormData.contact_number == "" || tempFormData.contact_number == null) {
            tempErrorFormData['contact_number'] = "Required field"
            valid = false
        } else {
            let modifiedString = deleteAndBefore(tempFormData.contact_number, phoneNumberDialCode);
            let countryCodeValue = phoneNumberCountryCode.toUpperCase();
            const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
            if (phoneNumber && phoneNumber.isValid()) {
                tempErrorFormData['contact_number'] = ""
            } else {
                tempErrorFormData['contact_number'] = "Enter valid phone number"
                valid = false
            }
        }

        if (tempFormData.email && tempFormData.email.trim() !== "") {
            var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            if (!expr.test(tempFormData.email.trim())) {
                tempErrorFormData['email'] = `${props.t('validEmail')}`
                valid = false;
            } else {
                tempErrorFormData['email'] = ""
            }
        } else {
            tempErrorFormData['email'] = ""
        }

        if (!selectAllBusiness) {
            // Check if at least one business has check: true
            let hasCheckedBusiness = selectedBusinessList.some(item => item.check === true);
            if (selectedBusinessList.length == 0 || !hasCheckedBusiness) {
                valid = false;
                Utility.toastNotifications('Please select at least one business', 'Warning', 'warning');
            }
        }
        setSupportUserFormDataError(tempErrorFormData)
        return valid;
    }

    //create or update support user data
    const submitSupportUserFn = (isSame = false) => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let vaildData = validationFromData();
        if (vaildData) {
            let data = formatingDataset(isSame);
            let type = 'post';
            let id = ""
            if (props.editedFlag) {
                id = props.editRowData.id
                type = "patch";
                data = data[0];
            }
            loaderStateTrue();
            supportCreate(data, id, type).then((response) => {
                if (type == "post") {
                    if (response.length > 0) {
                        response.map((data) => {
                            if (data.success) {
                                props.closeSupportUserModal(true);
                                Utility.toastNotifications(data.message, "Success", "success")
                            } else {
                                Utility.toastNotifications(data.message, "Error", "error")
                                loaderStateFalse();
                            }
                        })
                    }
                } else {
                    if (response.success) {
                        props.closeSupportUserModal(true);
                        Utility.toastNotifications(response.message, "Success", "success");
                        loaderStateFalse();
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error")
                        loaderStateFalse();
                    }
                }
                loaderStateFalse();
            }).catch((error) => {
                loaderStateFalse();
                if (error.response.status == 409) {
                    if (error.response.data.success == false && error.response.data.message == 'Same credential exists with different parametes') {
                        setCognitoUser(error.response.data.data)
                        setCognitoUserConfirmationPopUpFlag(true)
                    }
                }
            });
        }
    }

    const sameCredentialFn = () => {
        setCognitoUserConfirmationPopUpFlag(false)
        submitSupportUserFn(true)
    }

    const differentCredentialFn = () => {
        setCognitoUserConfirmationPopUpFlag(false)
        resetFromData();
    }

    const resetFromData = () => {
        setSupportUserFormData((prev) => ({
            ...prev,
            first_name: '',
            last_name: '',
            email: '',
            contact_number: '91',
        }));

        setSupportUserFormDataError((prev) => ({
            ...prev,
            first_name: '',
            last_name: '',
            email: '',
            contact_number: '',
        }));
        setPhoneNumberCountryCode("in");
        setPhoneNumberDialCode("91");
    }
    //assign business onclick function
    const handleAssignBusiness = (value) => {
        setBusinessListModalFlag(true);
    };

    //assign business modal close fn
    const closeBusinessListModalFn = () => {
        setBusinessListModalFlag(false);
    };

    //close assign business callback fn
    const closeAssignBusinessListModal = (type, data = [], selectAll = false, total_business = 0) => {
        if (type === 'save') {
            setSelectedBusinessList(data);
            setSelectAllBusiness(selectAll);
            setBusinessListModalFlag(false);
            setTotalBusiness(total_business);
        } else {
            setBusinessListModalFlag(false);
        }
    };

    useEffect(() => {
        if (cognitoUserConfirmationPopUpFlag) {
            const timer = setTimeout(() => {
                const backdrops = document.querySelectorAll('.modal-backdrop');

                // only target LAST backdrop (top-most modal)
                const latestBackdrop = backdrops[backdrops.length - 1];

                if (latestBackdrop) {
                    latestBackdrop.classList.add('my-custom-backdrop');
                }
            }, 10);

            return () => clearTimeout(timer);
        } else {
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach((el) => {
                el.classList.remove('my-custom-backdrop');
            });
        }
    }, [cognitoUserConfirmationPopUpFlag]);

    return (
        <div className="gridcontainer add_support_user_modal">
            <div className="modalinnerbody">
                <div className="innerbodydimension">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-9">
                                <div className="row">
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName='First Name'
                                                errorLabel={supportUserFormDataError.first_name}
                                                name="firstName"
                                                type="text"
                                                value={supportUserFormData.first_name}
                                                labelPresent={true}
                                                onChange={(e) => handelChange(e, 'first_name')}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName="Last Name"
                                                errorLabel={supportUserFormDataError.last_name}
                                                name="name"
                                                type="text"
                                                value={supportUserFormData.last_name}
                                                labelPresent={true}
                                                onChange={(e) => handelChange(e, 'last_name')}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName="Email"
                                                errorLabel={supportUserFormDataError.email}
                                                name="email"
                                                type="text"
                                                value={supportUserFormData.email}
                                                labelPresent={true}
                                                onChange={(e) => handelChange(e, 'email')}
                                                readOnly={props.editedFlag ? true : false}
                                                requiredStar={false}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input_field_inner_phone'>
                                            <ErrorBoundary title="PhoneInput Error">
                                                <PhoneNumberWithCountryCode
                                                    disabled={props.editedFlag ? true : false}
                                                    country={phoneNumberCountryCode}
                                                    value={supportUserFormData.contact_number}
                                                    onChange={(e, country) => handelChange(e, 'contact_number', country)}
                                                    error={supportUserFormDataError.contact_number}
                                                    labelShow={true}
                                                    requirStart={true}
                                                />
                                            </ErrorBoundary>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="user_add_img modprofile userprofile_img">
                                    <div className="userProfileImg">
                                        {!addProfileImagePreviewShow ?
                                            <label className="custom-file-upload">
                                                <span className="filetext">
                                                    <img src={addprofileImageSelected}
                                                    />
                                                </span>
                                                <span className="plusicon">
                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                    <input type="file"
                                                        accept={Utility.acceptFileType()}
                                                        onChange={addInputProfileImageChanged}
                                                    />
                                                </span>
                                            </label> :
                                            <label className="custom-file-upload">
                                                <img src={addprofileImageSelected} />
                                                <span className="plusicon">
                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                    <input type="file"
                                                        accept={Utility.acceptFileType()}
                                                        onChange={addInputProfileImageChanged}
                                                    />
                                                </span>
                                            </label>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 selectedBusinessSec">
                                <div className='selectedBusinessSecTop'>
                                    <button
                                        onClick={handleAssignBusiness}
                                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 selectedBusinessBtn"
                                    >+ Assign Business <span>*</span>
                                    </button>
                                </div>
                                <ul className='selectedBusinessUL'>
                                    {displayedItems.map((option) => (
                                        option.check ?
                                            <li key={option.value} className="flex justify-between items-center">
                                                {option.org_name.length > 25 ? (
                                                    <OverlayTrigger overlay={<Tooltip className="my-custom-tooltip">{option.org_name}</Tooltip>}>
                                                        <span>{(option.org_name).substring(0, 22) + "..."}</span>
                                                    </OverlayTrigger>
                                                ) : (
                                                    <span>{option.org_name}</span>
                                                )}
                                            </li>
                                            : null
                                    ))}

                                    {/* Show More/Show Less Button */}
                                    {selectedBusinessList.length > maxItems && (
                                        <li className='showAllBtnLI'>
                                            <button
                                                onClick={() => setIsExpanded(!isExpanded)}
                                                className="showAllBtn"
                                            >
                                                {isExpanded ? '...Show Less' : 'Show All...'}
                                            </button>
                                        </li>)}
                                </ul>
                                {
                                    selectAllBusiness && !props.editedFlag && !isExpanded ?
                                        <div className="" style={{ fontSize: '13px' }}>
                                            +{totalBusiness - selectedBusinessList.length} more businesses
                                        </div>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 text-center topspace">
                    <button type="button" className="modBtnSave" onClick={(e) => submitSupportUserFn()}>Submit</button>
                    <button type="button" className="modBtnSave cancelbtn" onClick={(e) => props.closeSupportUserModal()}>Cancel</button>
                </div>
            </div>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={imageCropModalFlag}
                    onHide={imageCropModalHide}
                    onCancel={imageCropModalHide}
                    onSave={imageCropDataSave}
                    className="modalcustomizeDialog cropmodalcontentDialog"
                    bodyClassName="cropmodalcontentbody"
                    headerclassName="close_btn_icon"
                    title={'Crop Image'}
                    footer={true}
                    closeButton={true}
                    saveButtonLabel={'Crop'}
                    saveButtonClassName="delconfirmbtn btn btn-primary"
                    cancelButtonClassName="delcancelbtn btn btn-primary"
                    body={
                        <>
                            <ErrorBoundary title="ModalGlobal Error">
                                <ImageCropContent
                                    onImageLoaded={onImageLoaded}
                                    onComplete={onCropComplete}
                                    onCropChange={onCropChange}
                                    crop={crop}
                                    croppedImageUrl={croppedImageUrl}
                                    src={src}
                                    onCropComplete={onCropComplete}
                                    imageCropModalShow={imageCropModalShow}
                                    circularCrop={false}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={businessListModalFlag}
                    onHide={closeBusinessListModalFn}
                    title={'Assign Business'}
                    className="modalcustomizeDialog mondimension supportUserModal viewBusinessListModal"
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn"
                    cancelShow={true}
                    body={
                        <>
                            <ErrorBoundary title="viewBusinessListModal Error">
                                <AssignBusinessModalContent
                                    selectedBusinessList={selectedBusinessList}
                                    closeAssignBusinessListModal={closeAssignBusinessListModal}
                                    selectAllBusiness={selectAllBusiness}
                                    supportUserId={props.editRowData.id}
                                    setExcludeId={setExcludeId}
                                    excludeId={excludeId}
                                    setSelectAllBusinessOnlyAction={setSelectAllBusinessOnlyAction}
                                    selectAllBusinessOnlyAction={selectAllBusinessOnlyAction}
                                    editedFlag={props.editedFlag}
                                    setincludeId={setincludeId}
                                    includeId={includeId}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={cognitoUserConfirmationPopUpFlag}
                    onHide={() => setCognitoUserConfirmationPopUpFlag(false)}
                    className="modalcustomize confirmationalertmodal confirmationalertmodalUnifiedCognito"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="User Confirmation"
                    footer={false}
                    closeButton={true}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent={<>
                                        <p>Do you want to use the same credentials for this user?</p>
                                    </>}
                                    BodySecondContent={<>
                                        <div class="user-info-card">
                                            <div class="user-info-row">
                                                <span class="label">First Name</span>
                                                <span class="value">{`${cognitoUser?.first_name}` || ""}</span>
                                            </div>
                                            <div class="user-info-row">
                                                <span class="label">Last Name</span>
                                                <span class="value">{`${cognitoUser?.last_name}` || ""}</span>
                                            </div>
                                            <div class="user-info-row">
                                                <span class="label">Phone Number</span>
                                                <span class="value">{cognitoUser?.contact_number ? cognitoUser?.contact_number.includes('+') ? cognitoUser?.contact_number : '+' + cognitoUser?.contact_number : ''}</span>
                                            </div>
                                            {cognitoUser?.email ?
                                                <div class="user-info-row">
                                                    <span class="label">Email</span>
                                                    <span class="value">{cognitoUser?.email || ''}</span>
                                                </div>
                                                : null}
                                        </div>
                                    </>}
                                    BodyThirdContent={''}
                                    confirmationButtonContent="Same Credential"
                                    cancelButtonContent="Different Credential"
                                    deleteConfirmButton={sameCredentialFn}
                                    deleteCancleButton={differentCredentialFn}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
        </div>
    )
}

AddSupportUserModalContent.defaultProps = {
    editedFlag: false
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}


export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withNamespaces()(AddSupportUserModalContent));